import React, { Component } from "react";
import Button from "../../../../components/bases/button/button";
import Dialog from "../../../dialogs/dialog";
import DialogInput from "../../../dialogs/input";
import ClientsDiffusorsForm from "./clientsdiffusorsform"

import imgselect from "../assets/select2.png"
import imgedit from "../assets/edit.png"
import imgdelete from "../assets/delete.png"

import "../../tables/tables.css"

import { apiGetClientsList } from "../../../../utils/apis";
import { apiGetDiffusorsList } from "../../../../utils/apis";

class ClientsDiffusorsList extends Dialog
{
  constructor(props) 
  {
    super(props);
    // props table = "CLIENTS", "DIFFUSEURS"
    // current = valeur en cours ou 0
    // select = {true} si on peut séléctionner


    const title =   this.props.table=="CLIENTS"? {en:"Clients List",  fr:"Liste des clients",}: {en:"Diffusors List",  fr:"Liste des Diffuseurs",}
    this.state.title = title;
    this.state.displayform = false;
    this.state.formaction = ""; // add / edit / remove 
    this.state.formulaire = {}
    this.state.recherche = "";

    this.state.current = this.props.current;

    var buttons = [];

    if (this.props.select)
    {
        buttons.push({type:"text", disabled:false,text:{fr:"Non précisé",en:"Unselect"},key:"unselect"})
        buttons.push({type:"text", disabled:false,text:{fr:"Sélectionner",en:"Select"},key:"select"})
    }
    buttons.push({type:"text", disabled:false,text:{fr:"Ajouter",en:"Add"},key:"add"})
    buttons.push({type:"back", disabled:false});

    this.state.buttons = buttons;
    this.state.liste = [];
    this.state.columms = [];

    this.rechercheRef = React.createRef();

    this.handleButton =  this.handleButton.bind(this);
    this.handleDeleteButton = this.handleDeleteButton.bind(this)
    this.handleEditButton = this.handleEditButton.bind(this);
    this.handleSelectButton = this.handleSelectButton.bind(this);
    this.onvalidform = this.onvalidform.bind(this);
    this.handleOnChangeRecherche = this.handleOnChangeRecherche.bind(this)
    this.onGetTableList = this.onGetTableList.bind(this)

    this.onQuit = this.onQuit.bind(this)


   
  }

  handleButton(buttonkey)
  {
    
    switch (buttonkey)
    {
        case "add":
          this.cancelKey = true;
            this.setState({displayform:true, formaction:"add"});
            break;
        case "back":
          this.onQuit();
          break;
        case "unselect":
          if (this.props.table == "CLIENTS")
            this.props.onvalidform({ret:true, clid:0})
          else
          this.props.onvalidform({ret:true, diid:0})
          break;
        case "select":
          if (this.props.table == "CLIENTS")
            this.props.onvalidform({ret:true, clid:this.state.current})
          else
            this.props.onvalidform({ret:true, diid:this.state.current})
          break;
          
      }
   
  }

  handleOnChangeRecherche()
  {

    var recherche = this.rechercheRef.current.getValue();
    if (recherche != this.state.recherche)
      this.setState({recherche: recherche})
  }


  onQuit()
  {
    
      this.props.onvalidform({ret:false})
  }

  onValid()
  {
    alert ("on valide");
  }
  onvalidform(ret)
  {

    this.cancelKey = false;
    
      

      
      this.setState({displayform:false});
      if (ret.ok)
      {

        if ((ret.action === "add") && (this.props.select))
        {
            if (this.props.table == "CLIENTS")
                this.props.onvalidform({ret:true, clid:ret.id})
            else
              this.props.onvalidform({ret:true, diid:ret.id})
            return;
        }


        if (this.props.table == "CLIENTS")
          apiGetClientsList (this.onGetTableList);
        else
          apiGetDiffusorsList (this.onGetTableList);
      }
  }

  onGetTableList(datas)
  {
    
    this.setState({liste:datas});
  }
  componentDidMount()
  {
    super.componentDidMount();

    if (this.props.table == "CLIENTS")
      apiGetClientsList (this.onGetTableList);
    else
      apiGetDiffusorsList (this.onGetTableList);


    var idf="di";
    if (this.props.table == "CLIENTS") idf = "cl";

    var txtname = this.context.language=="fr"?"Nom":"Name";
    var txtphone = this.context.language=="fr"?"Téléphone":"Phone";
    var txtpicture = this.context.language=="fr"?"Image":"Picture";

    var columms = [
      {text:"Id", width:5, zone: idf+"id", type:"text", align:"center"},
      {text:txtname, width:22, zone: idf+"name", type:"text", align:"left"},
      {text:"Contact", width:20, zone: idf+"contact", type:"text", align:"left"},
      {text:"Mail", width:20, zone: idf+"mail", type:"text", align:"left"},
      {text:txtphone, width:13, zone: idf+"phone", type:"text", align:"center"},
      {text:txtpicture, width:8, zone: idf+"image", type:"image", align:"center"},
      {text:"Actions", width:17, zone: idf+"action", type:"actions", align:"center"}
  ]
     this.setState({columms: columms})


  }

  handleSelectButton(id)
  {
    if (this.props.select)
    {
      this.setState({current:id})
    } 
  }

  handleEditButton(datas)
  {
    this.cancelKey = true;
    this.setState({displayform:true, formaction:"edit", formulaire:datas});

  }

  handleDeleteButton(datas)
  {
    this.cancelKey = true;
    this.setState({displayform:true, formaction:"delete", formulaire:datas});
    

  }


  render()
  {


    var maxwidth =  (window.innerWidth * 75)/100;
    if (maxwidth > 1200) maxwidth = 1200;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 300) maxheight = 300;

    var localrender =[];
    
    var listelement = [];
    
    var recherche = this.state.recherche.trim().toLowerCase();

    

    var n=0;


    for (let i=0; i < this.state.liste.length; i++)
    {
      var style = {backgroundColor: "transparent"};
      if (n&1)
        style = {backgroundColor: "#080808"};
      let id = 0;
      if (this.props.table == "CLIENTS")      
        id = this.state.liste[i].clid;
      else
        id = this.state.liste[i].diid;

      if (this.state.current == id)
        style.backgroundColor = "#7E97BC"; // #9EB7CC";


      var nom="";
      var contact="";
      var displayit = true;

      if (recherche !=="")
      {

          if (this.props.table == "CLIENTS")
          {
              nom = this.state.liste[i]["clname"].toLowerCase();
              contact = this.state.liste[i]["clcontact"].toLowerCase();
          }

          else

          {
              nom = this.state.liste[i]["diname"].toLowerCase();
              contact = this.state.liste[i]["dicontact"].toLowerCase();
          } 

          displayit=false;
          if (nom.includes(recherche)) displayit=true;
          if (contact.includes(recherche)) displayit=true;


      }
      if (displayit)
      {
      listelement.push(
          <tr style={style} onClick={e=>{this.handleSelectButton(id);}}>
          <ListTableElement 
          select = {this.props.select}
          current = {this.state.current}
          onedit = {this.handleEditButton}
          ondelete = {this.handleDeleteButton}
          onselect = {this.handleSelectButton}
          
          index={i} columms = {this.state.columms} values = {this.state.liste[i]} />  
          </tr>
        )
      }

      n=n+1;
    }

    localrender.push(
      <>
      <DialogInput
                  value = {this.state.recherche}
                  disabled={false}
                  autoFocus = {true}
                  ref = {this.rechercheRef}
                  onChange =  {this.handleOnChangeRecherche}
                  readOnly = {false}
                  width = "400px"
                  
                  title = {this.context.language=="fr"?"Recherche par nom ou contact :":"Search by name or contact"}

                />        
                
            <div className="table-limit" style={{width:maxwidth, height:maxheight}}>

            <div className="table-container-header">
            <table className="table-tableList" cellSpacing={5} cellPadding={0}>
            <ListTableHeader columms = {this.state.columms} />          
            </table>
            </div>
            <div className="table-container">
            <table className="table-tableList" cellSpacing={5} cellPadding={0}>
                
                  {listelement}
            </table>      
            </div>
            </div>          
                

      </>          
      );

      if (this.state.displayform)
        {
            localrender.push(
                    <>
                      <ClientsDiffusorsForm table={this.props.table}
                          zindex = {this.props.zindex+1}
                          display = {this.state.displayform}
                          startposition = "right"
                          closeButton = {true}
                          onvalidform = {this.onvalidform}
                          formulaire = {this.state.formulaire}
                          action = {this.state.formaction} />
                    </>
                  );
    
        }
        


    return super.render(localrender);
  }


}
ClientsDiffusorsList.defaultProps = 
{
    table: "CLIENTS",
    selectButton: false,
    current: 0,
    zorder:2,
}

//  ****************************************************************************************
//  ListTablesHeader
//  ****************************************************************************************
class ListTableHeader extends React.Component{
    constructor(props)
    {
        super(props);
    }

    createAllHeaderColumms()
    {
        var retour = []
        var styleh = "table-headerList"
        for (var i=0; i<this.props.columms.length; i++)
        {
            var width = this.props.columms[i].width + "%"
            var key="userheader" + i;
          retour.push(
              
              <td width={width} className={styleh} key={key}>
              
                  {this.props.columms[i].text}
              </td>)
        }
        return ( retour)
    }


  render()
  {
      return (
          <>
                  {this.createAllHeaderColumms()}
          </>
      )
  }

}


//  ****************************************************************************************
//  ListTableElement
//  ****************************************************************************************
class ListTableElement extends React.Component{
  constructor(props)
  {
      super(props);
  }



  createAllElementColumms()
  {
      var retour = []

      var styleh = "table-elementList"
      for (var i=0; i<this.props.columms.length; i++)
      {
          var width = this.props.columms[i].width + "%"
          var key="userelement" + i;


          var style = {height:"32px", textAlign: this.props.columms[i].align, paddingLeft:"3px", borderRadius:"4px"};
        switch (this.props.columms[i].type)
        {
          case "text":
            retour.push(
                
                <td width={width} className={styleh} key={key} style={style}>
                
                    {this.props.values[this.props.columms[i].zone]}
                </td>)
            break;
            case "image":
              if (this.props.values[this.props.columms[i].zone] =="")
                retour.push(<td width={width} className={styleh} key={key} style={style}>&nbsp;</td>);
              else
              retour.push(<td width={width} className={styleh} key={key} style={style}>
                  <img height="32" src={this.props.values[this.props.columms[i].zone]}/>
                    </td>);

                
              break;
          case "actions":


            retour.push(
                
              <td width={width} className={styleh} key={key} style={style}>

                <Button 
                button={true}
                image={imgedit}
                tooltip={{fr:"Modifier",en:"Edit"}} 
                disable={false}
                datas={this.props.values}
                onClick={this.props.onedit}
                width={20} height={20}/>

                &nbsp;

                <Button 
                button={true}
                image={imgdelete}
                tooltip={{fr:"Supprimer",en:"Delete"}} 
                disable={false}
                datas={this.props.values}
                onClick={this.props.ondelete}
                width={20} height={20}/>

                &nbsp;



              </td>)
            break;
            break;
        }
      }
      return ( retour)
  }


render()
{
    return (
        <>
                {this.createAllElementColumms()}
        </>
    )
}

}


export default ClientsDiffusorsList;